import appService from 'src/pl.service';
import { GET_MY_PERMISSIONS } from 'src/store/actions/types';

/**
 * retrieves the "my permissions" from the API and
 * commits the data to the store using the GET_MY_PERMISSIONS action type
 */
export const getMyPermissions = async ({ commit }) =>
  commit(GET_MY_PERMISSIONS, await appService.getMyPermissions());
